var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAvidxCoinsPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1019_1797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1019_1797)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.5C22 17.299 17.299 22 11.5 22C5.70101 22 1 17.299 1 11.5C1 5.70101 5.70101 1 11.5 1C17.299 1 22 5.70101 22 11.5ZM23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM20.6998 11.5C20.6998 16.581 16.5808 20.7 11.4998 20.7C6.41879 20.7 2.2998 16.581 2.2998 11.5C2.2998 6.41898 6.41879 2.3 11.4998 2.3C16.5808 2.3 20.6998 6.41898 20.6998 11.5ZM13.816 12.6482L13.032 8.6882C13 8.50686 12.9627 8.2962 12.92 8.0562C12.8773 7.81619 12.8347 7.55486 12.792 7.27219C12.6853 7.55486 12.5813 7.81619 12.48 8.0562C12.3787 8.2962 12.288 8.50953 12.208 8.69619L10.456 12.6482H13.816ZM16.832 17.0002H15.224C15.0427 17.0002 14.9013 16.9575 14.8 16.8722C14.704 16.7815 14.6347 16.6669 14.592 16.5282L14.112 14.1122H9.8L8.728 16.5282C8.66933 16.6509 8.57333 16.7602 8.44 16.8562C8.312 16.9522 8.16267 17.0002 7.992 17.0002H6.36L11.952 5.43219H14.072L16.832 17.0002Z",
    fill: "#7C7B7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvidxCoinsPassive);
export default __webpack_public_path__ + "static/media/icon-avidx-coins-passive.c740b00c9fa1d235d83712288270540f.svg";
export { ForwardRef as ReactComponent };